import {
  Button,
  Flex,
  FormControl,
  IconButton,
  Input,
  Box,
} from "@chakra-ui/react"
import {
  Controller,
  FieldValues,
  UseFieldArrayReturn,
  useFormContext,
  useFormState,
  useWatch,
} from "react-hook-form"
import { AddIcon, DeleteIcon } from "@chakra-ui/icons"
import React from "react"
import { FormattedMessage, useIntl } from "react-intl"
import { ControlledSelect } from "../../ControlledSelect"
import { TcoFormData } from "../../../TcoForm"
import { Pipe } from "../../../../../models/pipe"

export type BondedPipeControlProps = {
  pipes: Pipe[]
  fieldArrayMethods: UseFieldArrayReturn<FieldValues, "bondedPipes", string>
  printMode?: boolean
}

export const BondedPipeControl: React.FC<BondedPipeControlProps> = ({
  pipes,
  fieldArrayMethods,
  printMode = false,
}) => {
  const intl = useIntl()
  const { register, control } = useFormContext<TcoFormData>()
  const { fields, append, remove } = fieldArrayMethods
  const values = useWatch({ control, name: "bondedPipes" })
  const { errors } = useFormState<TcoFormData>()
  return (
    <Flex flexDirection={"column"} width={425} pt={4}>
      {fields.map((item, index) => {
        return (
          <Flex
            mt={2}
            flexDirection={"row"}
            justifyContent={"space-between"}
            key={item.id}
          >
            <FormControl
              width="150px"
              isInvalid={errors?.bondedPipes?.[index]?.meters != null}
              isReadOnly={printMode}
            >
              <Input
                textAlign="center"
                placeholder={intl.formatMessage({
                  id: "bonded-pipes.metre-trench",
                  defaultMessage: "Metre trench",
                })}
                defaultValue={item.meters}
                autoFocus
                type="number"
                {...register(`bondedPipes.${index}.meters` as any, {
                  required: true,
                  min: 1,
                })}
              />
            </FormControl>

            <Box width="200px">
              <Controller
                name={`bondedPipes.${index}.pipeId` as any}
                control={control}
                defaultValue={item.pipeId}
                rules={{ required: true }}
                render={({ field }) => (
                  <FormControl
                    isInvalid={errors?.bondedPipes?.[index]?.pipeId != null}
                    isReadOnly={printMode}
                  >
                    <ControlledSelect
                      options={pipes}
                      selectedOptionIds={values.map((p) => p.pipeId)}
                      onChange={(selectedPipeId: string) =>
                        field.onChange(selectedPipeId)
                      }
                      value={field.value}
                      isReadOnly={printMode}
                    />
                  </FormControl>
                )}
              />
            </Box>

            {!printMode && (
              <IconButton
                type="button"
                borderRadius="md"
                onClick={() => remove(index)}
                aria-label="delete pipe"
                icon={<DeleteIcon />}
              />
            )}
          </Flex>
        )
      })}

      {!printMode && (
        <Button
          mt={2}
          width={150}
          type="button"
          leftIcon={<AddIcon />}
          onClick={() => append({ meters: "" })}
        >
          <FormattedMessage
            id="app.addPipeRow"
            defaultMessage="Add"
            description="Add pipe to include in TCO calculation"
          />
        </Button>
      )}
    </Flex>
  )
}
